export default "__VITE_ASSET__BeGJHVM6__"